import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from "@material-ui/core";
import {
  Button,
  Typography,
  Grid,
  Box,
  TextField,
  MenuItem,
  Alert,
} from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { showAlert } from "../../../../actions/alert";
import { createTeamsMeeting } from "../../../../api/teamsMeetings";
import { handleAxiosError } from "../../../../config/action-config";
import { teamsLogin } from "../../../../api/auth";
import { getMeetingDetailsbyId } from "../../../../api/appraisal";

export default function MeetingForm() {
  const [save, setSave] = useState(false);
  const appraisalData = useSelector((state) => state.appraisalUser);
  const [meetingData, setMeetingData] = useState({});
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const emptyEventData = {
    appraisal_id: "",
    subject: "",
    start: null,
    end: null,
    attendees: "",
  };
  const [data, setData] = useState(emptyEventData);

  const handleDataChange = (target) => {
    setData((prev) => ({ ...prev, [target.name]: target.value }));
  };

  useEffect(() => {
    if (!appraisalData.emp_id) {
      navigate("/appraisal");
      return;
    }
  }, [appraisalData.emp_id, navigate]);

  const onCreateFormSubmit = async () => {
    data.appraisal_id = appraisalData.appraisal_id;
    let updatedData = {
      appraisal_id: data.appraisal_id,
      subject: data.subject,
      start: createDateAsUTC(data.start),
      end: createDateAsUTC(data.end),
    };
    let attendees = [
      {
        email: appraisalData.emp_email,
        id: appraisalData.emp_id,
        name: appraisalData.emp_name,
      },
      {
        email: user.email,
        id: user.id,
        name: user.firstname,
      },
    ];
    try {
      const { error } = await createTeamsMeeting(
        { ...updatedData, attendees },
        user.token,
        user.msTeamsAuth
      );
      if (error) throw error;
      dispatch(showAlert("Meeting Scheduled."));
      setSave(false);
      navigate("/appraisal");
    } catch (error) {
      handleAxiosError(error, dispatch);
      setSave(false);
    }
  };

  useEffect(() => {
    getMeetingDetail();
  }, []);

  async function getMeetingDetail() {
    try {
      const { data } = await getMeetingDetailsbyId(params.id, user.token);
      setMeetingData(data.data);
    } catch (err) {
      handleAxiosError(err);
      return { error: true };
    }
  }

  const onLinkAccountClick = async () => {
    try {
      const { data } = await teamsLogin(user.token);
      window.location.replace(data.link);
    } catch (error) {
      dispatch(showAlert(error));
    }
  };

  if (!user.msTeamsAuth)
    return (
      <Paper elevation={3} sx={{ display: "flex", justifyContent: "center" }}>
        <Box p={1} textAlign="center">
          <Alert severity="info">
            To Schedule the meeting You need to link your Microsoft Teams
            Account to Schedule the Teams Meeting.
          </Alert>

          <Button
            sx={{ mt: 1 }}
            variant="contained"
            onClick={onLinkAccountClick}
            color="secondary"
          >
            Link Account
          </Button>
        </Box>
      </Paper>
    );

  return (
    <Grid
      container
      spacing={2}
      sx={{ display: "flex", justifyContent: "center" }}
      style={{ margin: "35px" }}
    >
      <Paper elevation={5} square={false}>
        <Box
          style={{ height: "450px", width: "100%" }}
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            setSave(true);
          }}
        >
          <Grid item xs={12} md={6} sm={6} sx={{ m: "10px" }}>
            <Box className="typography-title">
              <Typography variant="h1" className="appraisal-heading-h1">
                Schedule a Meeting
              </Typography>
            </Box>
          </Grid>
          <Grid
            container
            spacing={3}
            className=""
            sx={{ display: "flex", justifyContent: "center", m: 2, mb: 2 }}
          >
            <Grid item xs={10} md={5} sm={5}>
              <TextField
                name="subject"
                fullWidth
                label="Meeting Title"
                type="text"
                value={data.subject}
                onChange={(e) => handleDataChange(e.target)}
                required
              />
            </Grid>
            <Grid item xs={10} md={5} sm={5}>
              <TextField
                name="attendees"
                fullWidth
                label="Attendees"
                type="text"
                color="secondary"
                value={appraisalData.emp_name + ",  " + user.firstname}
                disabled
                required
              />
            </Grid>

            <Grid item xs={10} md={10} sm={10}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="Meeting Start On"
                  required
                  disablePast
                  minDateTime={new Date()}
                  value={data.start}
                  onChange={(newValue) => {
                    handleDataChange({
                      name: "start",
                      value: newValue,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={10} md={10} sm={10}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="Meeting End On"
                  required
                  disablePast
                  minDateTime={data.start || new Date()}
                  value={data.end}
                  onChange={(newValue) => {
                    handleDataChange({
                      name: "end",
                      value: newValue,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={10} md={5} sm={5}></Grid>
            <Grid item xs={10} md={5} sm={5}></Grid>
          </Grid>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "20px",
              margin: "14px",
            }}
          >
            <Button
              size="medium"
              sx={{
                borderRadius: "10px",
                fontWeight: "bold",
                fontSize: "14px",
              }}
              variant="contained"
              color="inherit"
              onClick={() => navigate("/appraisal")}
            >
              Cancel
            </Button>

            <Button
              size="medium"
              sx={{
                borderRadius: "10px",
                fontWeight: "bold",
                fontSize: "14px",
              }}
              variant="contained"
              color="info"
              type="submit"
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Paper>

      <Dialog
        open={save}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <>
          <DialogTitle id="alert-dialog-title">Confirm Submit</DialogTitle>
          <DialogContent style={{ width: "500px" }}>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to Submit?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size="medium"
              onClick={() => {
                setSave(false);
              }}
              variant="contained"
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              size="medium"
              onClick={() => {
                onCreateFormSubmit();
              }}
              variant="contained"
              color="info"
            >
              Confirm
            </Button>
          </DialogActions>
        </>
      </Dialog>
    </Grid>
  );
}
function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
}
